import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createLectureVouchers } from "../../../../services/dashboard/apiLecture";

export function useCreateLectureVouchers() {
  const queryClient = useQueryClient();

  const {
    mutate: createVouchers,
    isLoading: isCreating,
    error,
    data: vouchers,
  } = useMutation({
    mutationFn: createLectureVouchers,
    onSuccess: () => {
      toast.success("تم إنشاء الأكواد بنجاح");
      queryClient.invalidateQueries({
        queryKey: ["vouchers"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { createVouchers, isCreating, error, vouchers };
}
